export default "__VITE_ASSET__1J3VanoR__"